const API_BASE_URL = 'https://nodnummer-php-b4qscrz0.on-forge.com/v1';

export const API_ENDPOINTS = {
  BASE_URL: API_BASE_URL,
  CHURCHES: `${API_BASE_URL}/churches`,
  COUNTRIES: `${API_BASE_URL}/countries`,
  EMBASSIES: `${API_BASE_URL}/embassies`,
  CHAPLAINS: `${API_BASE_URL}/chaplains`,
  EMERGENCY_NUMBERS: `${API_BASE_URL}/emergency-numbers`,
  INSURANCE_PROVIDERS: `${API_BASE_URL}/insurance-providers`,
  MESSAGES: `${API_BASE_URL}/messages`,
};

export default API_BASE_URL;
